import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ReportsMetricsHttpClient } from './metrics.http-client';
import { ReportsMetricsActions } from './metrics.store';

@Injectable({
  providedIn: 'root',
})
export class ReportsMetricsEffects {
  public effects = createEffectFactory(ReportsMetricsActions, this.actions$);

  public fetchCollection$ = this.effects(ReportsMetricsActions.fetchCollection, () =>
    this.http.fetchCollection().pipe(map(({ metrics }) => ({ data: metrics }))),
  );

  constructor(
    private actions$: Actions,
    private http: ReportsMetricsHttpClient,
  ) {}
}
